export const COLLECTION_PAGE_CANONICALS = Object.freeze({
  '/collections/vlone-apparel': 'https://www.goat.com/apparel/brand/vlone',
  '/collections/mcq': 'https://www.goat.com/brand/mcq',
  '/collections/burberry-arthur-sneaker':
    'https://www.goat.com/sneakers/silhouette/burberry-arthur',
  '/collections/supreme': 'https://www.goat.com/apparel/brand/supreme',
  '/collections/bape': 'https://www.goat.com/apparel/brand/bape',
  '/collections/dior': 'https://www.goat.com/sneakers/brand/dior',
  '/collections/chrome-hearts': 'https://www.goat.com/apparel/brand/chrome-hearts',
  '/collections/new-in-from-alexander-mcqueen': 'https://www.goat.com/brand/alexander-mcqueen',
  '/collections/new-off-white': 'https://www.goat.com/apparel/brand/off-white',
  '/collections/air-jordan-2020-2021': 'https://www.goat.com/sneakers/brand/air-jordan',
  '/collections/comme-des-garcons-sneakers': 'https://www.goat.com/brand/comme-des-garcons',
  '/collections/travis-scott-bb79679b-ecc4-4ad8-a7ab-107bb548afbe':
    'https://www.goat.com/brand/travis-scott',
  '/collections/gucci': 'https://www.goat.com/brand/gucci',
  '/collections/dior-apparel': 'https://www.goat.com/apparel/brand/dior',
  '/collections/clot': 'https://www.goat.com/brand/clot',
  '/collections/raf-simons': 'https://www.goat.com/sneakers/brand/raf-simons',
  '/collections/acne-studios-apparel': 'https://www.goat.com/apparel/brand/acne-studios',
  '/collections/palm-angels-apparel': 'https://www.goat.com/brand/palm-angels',
  '/collections/rhude': 'https://www.goat.com/brand/rhude',
  '/collections/trending-essentials': 'https://www.goat.com/apparel/brand/fear-of-god-essentials',
  '/collections/palace': 'https://www.goat.com/apparel/brand/palace',
  '/collections/bottega-veneta': 'https://www.goat.com/brand/bottega-veneta',
  '/collections/pleasures-apparel': 'https://www.goat.com/apparel/brand/pleasures',
  '/collections/stussy-collection': 'https://www.goat.com/apparel/brand/stussy',
  '/collections/kith': 'https://www.goat.com/brand/kith',
  '/collections/aries': 'https://www.goat.com/apparel/brand/aries',
  '/collections/rick-owens': 'https://www.goat.com/brand/rick-owens',
  '/collections/balenciaga-apparel': 'https://www.goat.com/apparel/brand/balenciaga',
  '/collections/chinatown-market-apparel': 'https://www.goat.com/apparel/brand/chinatown-market',
  '/collections/cdg-cb52cd5d-e7d7-492d-89bd-ba17a36a31e9':
    'https://www.goat.com/brand/comme-des-garcons',
  '/collections/cactus-plant-flea-market': 'https://www.goat.com/brand/cactus-plant-flea-market',
  '/collections/off-white-apparel-accessories': 'https://www.goat.com/sneakers/brand/off-white',
  '/collections/mm6-maison-margiela': 'https://www.goat.com/apparel/brand/mm6-maison-margiela',
  '/collections/kidsuper': 'https://www.goat.com/brand/kidsuper',
  '/collections/vans': 'https://www.goat.com/brand/vans',
  '/collections/anti-social-social-club':
    'https://www.goat.com/apparel/brand/anti-social-social-club',
  '/collections/air-jordan-since-1985': 'https://www.goat.com/sneakers/brand/air-jordan',
  '/collections/aj7-since-1992': 'https://www.goat.com/sneakers/silhouette/air-jordan-7',
  '/collections/nike-dunk': 'https://www.goat.com/sneakers/silhouette/dunk',
  '/collections/alexander-mcqueen': 'https://www.goat.com/sneakers/brand/alexander-mcqueen',
  '/collections/amq': 'https://www.goat.com/brand/alexander-mcqueen',
  '/collections/air-jordan-4': 'https://www.goat.com/sneakers/silhouette/air-jordan-4',
  '/collections/af1': 'https://www.goat.com/sneakers/silhouette/air-force-1',
  '/collections/nike-sb': 'https://www.goat.com/sneakers/silhouette/dunk-sb',
  '/collections/air-jordan-3': 'https://www.goat.com/sneakers/silhouette/air-jordan-3',
  '/collections/air-max-1': 'https://www.goat.com/sneakers/silhouette/air-max-1',
  '/collections/new-balance-2020': 'https://www.goat.com/sneakers/brand/new-balance',
  '/collections/fear-of-god-655fa0ae-f249-45b8-9a8e-3b09d0b9aacb':
    'https://www.goat.com/brand/fear-of-god',
  '/collections/air-jordan-11': 'https://www.goat.com/sneakers/silhouette/air-jordan-11',
  '/collections/margiela-apparel': 'https://www.goat.com/apparel/brand/maison-margiela',
});
